/**
 * Whether a venue is located in Italy.
 *
 * The backend exposes `restaurant.country` as a free-form string in mixed
 * languages ("Italia", "Italy", "Germania", …), so we normalize (lowercase +
 * trim) and match the known Italian spellings. An absent/unknown country is
 * treated as NON-Italian — the safe default whenever a rule (tax estimate,
 * mensilità, …) only holds under Italian labour law.
 *
 * NOTE: a small local twin lives in `apps/employer-app/libs/salary/
 * is-italian-venue.ts` (pay-transparency flow). It can't import this one without
 * dragging the whole utils-common barrel — incl. React hooks — into that pure
 * salary lib, so the Italian-spelling list is duplicated. Keep both in sync.
 */
export var isItalianVenue = function isItalianVenue(country) {
  var normalized = country === null || country === void 0 ? void 0 : country.toLowerCase().trim();
  return normalized === 'italia' || normalized === 'italy';
};